import ClientLayout from "../../../components/client/layout/ClientLayout";
import CreateClientProjectRequest from "../../../components/client/project/CreateClientProjectRequest";

//프로젝트 추가 요청 생성 페이지
const CreateClientProjectRequestInfoPage: React.FC = () => {

    return (
        <ClientLayout>
            {/*프로젝트 추가 요청 생성*/}
            <CreateClientProjectRequest/>
        </ClientLayout>
    );
};

export default CreateClientProjectRequestInfoPage;